import React from "react"

const defaultState = {
  
}

const InventoryContext = React.createContext(defaultState)
export default InventoryContext
